<template>
  <driver-form :is-new="true" />
</template>

<script>
import DriverForm from '../components/DriversForm.vue'

export default {
  components: {
    DriverForm,
  },
}
</script>

<style>

</style>
